// test2009
(2009 && 0);
